module.exports = __webpack_public_path__ + "resources/img/news-default-image.ec997e4331e61443075fdd6ab713d0a2.png";